import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/login";
import UsersInfoPage from "./pages/adminview";
import UserDetails from "./pages/userview";

function AppRoutes() {
    // Get the authentication status and user role from localStorage
    const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true';  
    const isAdmin = localStorage.getItem('isAdmin') === 'true';  

    return (
        <div className={"app"}>
            <Routes>
                {isAuthenticated ? (
                    <>
                        {isAdmin ? (
                            // Redirect to /members for admin users
                            <Route path="/" element={<Navigate to="/members" replace />} />
                        ) : (
                            // Redirect to /user-details for members
                            <Route path="/" element={<Navigate to="/user-details" replace />} />
                        )}

                        {/* Additional routes for authenticated users */}
                        {isAdmin ? (
                            <Route path="/members" element={<UsersInfoPage />} />
                        ) : (
                            <Route path="/user-details" element={<UserDetails />} />
                        )}
                    </>
                ) : (
                    // If not authenticated, show the LoginPage at '/'
                    <Route path="/" element={<LoginPage />} />
                )}

                {/* Catch-all route to redirect any unknown path to login page */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}

export default AppRoutes;
